import { render, staticRenderFns } from "./LocTest.vue?vue&type=template&id=26128e56&scoped=true&"
import script from "./LocTest.vue?vue&type=script&lang=js&"
export * from "./LocTest.vue?vue&type=script&lang=js&"
import style0 from "./LocTest.vue?vue&type=style&index=0&id=26128e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26128e56",
  null
  
)

export default component.exports